import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionUtil } from '../utils/auth-session.util';

export const authAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authSession = inject(AuthSessionUtil);

  if (authSession.isLoggedIn()) {
    return true;
  } else {
    return router.parseUrl('/login'); 
  }
};
